import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link, useNavigate } from "react-router-dom";
import ExtraView from "./Components/TotalIncomeExtraView";
import BankView from "./Components/TotalIncomeBankView";
import BonusDetailView from "./Components/BonusDetailView";
import {
  Button,
  Flex,
  Input,
  PaginationProps,
  Table,
  TableColumnsType,
  DatePicker,
  notification,
  Checkbox,
  Select,
  RefSelectProps,
} from "antd";
import {
  Calendar2,
  DocumentDownload,
  ExportSquare,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import "./style.scss";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
  EyeOutlined,
  DeleteOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { mixGetV1, mixPostV1 } from "../../services/mixin";
// @ts-ignore
import * as XLSX from "xlsx-js-style";
import { ExportReportManager } from "../../components/Interface/InterfaceTemp";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { RangePickerProps } from "antd/es/date-picker";
import MatchDetailView from "./Components/MatchDetailView";
import { start } from "repl";
import DeleteModal from "../../components/Modal/DeleteModal";
import { pencil } from "./Staff";
import EditReportIncomePoup from "./Components/EditReportIncomePoup";

const { RangePicker } = DatePicker;
const { Option } = Select;
const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current > dayjs().endOf("day");
};

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

interface DataType {
  key: React.Key;
  date: string;
  staff: string;
  bank: number;
  voucher: number;
  labor: number;
  match: number;
  foodsupply: number;
  money_proof: number;
  proof: number;
  final: number;
  profit: number;
  statusfinal: number;
  loss: number;
  payout_total: number;
  money_of_system: number;
  report_id: number;
  is_edit: number;
  zelle: number;
  baccarat: number;
}

interface RangeTimeFilter {
  date_id: number;
  label: string;
  from_date: string;
  to_date: string;
}

const ZelleCell: React.FC<{
  record: DataType;
  onSave: (reportId: number, zelleValue: number) => Promise<void>;
}> = ({ record, onSave }) => {
  const [val, setVal] = useState<string>(
    record.zelle !== undefined && record.zelle !== null
      ? record.zelle.toString()
      : "0",
  );
  const [isFocused, setIsFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVal(
      record.zelle !== undefined && record.zelle !== null
        ? record.zelle.toString()
        : "0",
    );
  }, [record.zelle]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(record.report_id, Number(val));
      setIsFocused(false);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex align="center" gap={4} justify="end" style={{ width: "100%" }}>
      {isFocused ? (
        <>
          <Input
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onBlur={() => {
              setTimeout(() => {
                setIsFocused(false);
              }, 200);
            }}
            onPressEnter={handleSave}
            autoFocus
            style={{
              color: "#f9d361",
              textAlign: "right",
              width: 80,
              border: "none",
              background: "transparent",
              boxShadow: "none",
              padding: "2px 4px",
            }}
            type="number"
          />
          <Button
            icon={<CheckOutlined style={{ color: "#55c790" }} />}
            size="small"
            loading={loading}
            onClick={handleSave}
            style={{
              padding: "0 4px",
              height: 24,
              width: 24,
              minWidth: 24,
              border: "1px solid #55c790",
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </>
      ) : (
        <span
          style={{
            borderBottom: "1px solid #f9d361",
            cursor: "pointer",
            color: "#f9d361",
          }}
          onClick={() => setIsFocused(true)}
        >
          {numberFormat(Number(val))}
        </span>
      )}
    </Flex>
  );
};

const BaccaratCell: React.FC<{
  record: DataType;
  onSave: (reportId: number, baccaratValue: number) => Promise<void>;
}> = ({ record, onSave }) => {
  const [val, setVal] = useState<string>(
    record.baccarat !== undefined && record.baccarat !== null
      ? record.baccarat.toString()
      : "0",
  );
  const [isFocused, setIsFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVal(
      record.baccarat !== undefined && record.baccarat !== null
        ? record.baccarat.toString()
        : "0",
    );
  }, [record.baccarat]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(record.report_id, Number(val));
      setIsFocused(false);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex align="center" gap={4} justify="end" style={{ width: "100%" }}>
      {isFocused ? (
        <>
          <Input
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onBlur={() => {
              setTimeout(() => {
                setIsFocused(false);
              }, 200);
            }}
            onPressEnter={handleSave}
            autoFocus
            style={{
              color: "#ffffff",
              textAlign: "right",
              width: 80,
              border: "none",
              background: "transparent",
              boxShadow: "none",
              padding: "2px 4px",
            }}
            type="number"
          />
          <Button
            icon={<CheckOutlined style={{ color: "#55c790" }} />}
            size="small"
            loading={loading}
            onClick={handleSave}
            style={{
              padding: "0 4px",
              height: 24,
              width: 24,
              minWidth: 24,
              border: "1px solid #55c790",
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </>
      ) : (
        <span
          style={{
            borderBottom: "1px solid #ffffff",
            cursor: "pointer",
            color: "#ffffff",
          }}
          onClick={() => setIsFocused(true)}
        >
          {numberFormat(Number(val))}
        </span>
      )}
    </Flex>
  );
};

const ReportTotalIncome: React.FC = () => {
  const navigate = useNavigate();
  const can_view_report_income =
    localStorage.getItem("can_view_report_income") ?? "0";
  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [sumReport, setSumReport] = useState({
    total_addbank: 0,
    total_bonus: 0,
    total_extra: 0,
    total_final: 0,
    total_labor: 0,
    total_loss: 0,
    total_match: 0,
    total_money_proof: 0,
    total_money_system: 0,
    total_payout: 0,
    total_profit: 0,
    total_start_amount: 0,
    total_voucher: 0,
    total_zelle: 0,
    total_baccarat: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [isShow, SetIsShow] = useState(false);
  const [dataView, SetDataView] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState<number>(0);
  const [isShowBank, SetIsShowBank] = useState(false);
  const [dataViewBank, SetDataViewBank] = useState(false);
  const [isShowBonus, setIsShowBonus] = useState(false);
  const [dataViewBonus, setDataViewBonus] = useState<any>(null);
  const [isShowMatch, setIsShowMatch] = useState(false);
  const [isSaveTime, setIsSaveTime] = useState(false);
  const [dataViewMatch, setDataViewMatch] = useState<number>();
  const [comboRangeTime, setComboRangeTime] = useState<RangeTimeFilter[]>([]);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [rangeValue, setRangeValue] = useState<
    [Dayjs | null, Dayjs | null] | null
  >(null);
  const selectRef = useRef<RefSelectProps>(null);
  const [exportingId, setExportingId] = useState<number | null>(null);

  const handleSaveZelle = async (reportId: number, zelleValue: number) => {
    const res = await mixPostV1("/api/webAdmin/updateZelleReportIncome.php", {
      report_id: reportId,
      zelle: zelleValue,
    });
    if (res.status === 1) {
      openNotification("success", "Zelle updated!");
      const updatedItems: any = items.list.map((item: any) =>
        item.report_id === reportId ? { ...item, zelle: zelleValue } : item,
      );
      setItems({
        ...items,
        list: updatedItems,
      });
    } else {
      openNotification("error", res.message || "Failed to update Zelle");
    }
  };

  const handleSaveBaccarat = async (
    reportId: number,
    baccaratValue: number,
  ) => {
    const res = await mixPostV1(
      "/api/webAdmin/updateBaccaratReportIncome.php",
      {
        report_id: reportId,
        baccarat: baccaratValue,
      },
    );
    if (res.status === 1) {
      openNotification("success", "Baccarat updated!");
      const updatedItems: any = items.list.map((item: any) =>
        item.report_id === reportId
          ? { ...item, baccarat: baccaratValue }
          : item,
      );
      setItems({
        ...items,
        list: updatedItems,
      });
    } else {
      openNotification("error", res.message || "Failed to update Baccarat");
    }
  };
  const exportDetailReport = async (reportId: number) => {
    setExportingId(reportId);
    try {
      const res = await mixPostV1(
        "/api/webAdmin/export_gDetailReportManager.php",
        { report_id: reportId },
      );

      if (res.status === 1 && res.data) {
        const data: ExportReportManager = res.data;
        const infoReport = data.infoReport;

        // Resolve store name
        const stores = JSON.parse(localStorage.getItem("stores") || "[]");
        const storeId = localStorage.getItem("storeId") || "";
        const currentStore = stores.find(
          (s: any) => s.key === storeId || s.store_id?.toString() === storeId,
        );
        const storeName = currentStore
          ? currentStore.store_name || currentStore.label
          : "";

        // Formatted Date
        const dateDownload = dayjs().format("MM/DD/YYYY");

        // Helper to format values
        const sumBank = Number(infoReport.start_amount) || 0;
        const sumCashOnHand = Number(infoReport.money_in_proof) || 0;
        const sumMatch = Number(infoReport.match_total) || 0;
        const sumPayout = Number(infoReport.payout_total) || 0;
        const sumBonus = Number(infoReport.bonus_total) || 0;
        const sumExtra = Number(infoReport.extra) || 0;

        const sumProfit = Number(infoReport.profit) || 0;
        const sumMoneySystem = Number(infoReport.money_of_system) || 0;
        const sumZelle = Number(infoReport.zelle) || 0;
        const sumBaccarat = Number(infoReport.baccarat) || 0;

        // Final formula: record.money_of_system - record.addbank + (record?.baccarat ?? 0)
        const finalVal = sumMoneySystem - sumBank + sumBaccarat;

        // Loss formula: record.loss + Number(record?.zelle) - (Number(record?.baccarat) || 0)
        const lossVal = (Number(infoReport.loss) || 0) + sumZelle - sumBaccarat;

        // Construct sheetData (Rows 0 to 5)
        const sheetData: any[][] = [
          [
            "Store Name",
            (infoReport as any).store_name || storeName || "",
            "Bank",
            sumBank,
            "Profit machine",
            sumProfit,
            "",
            "Final",
            finalVal,
          ],
          [
            "Date",
            infoReport.dateExport || dateDownload,
            "Cash on hand",
            sumCashOnHand,
            "Money of system",
            sumMoneySystem,
            "",
            "Loss",
            lossVal,
          ],
          [
            "Employee report",
            infoReport.staff_name || "",
            "Match",
            sumMatch,
            "Zelle",
            sumZelle,
          ],
          [
            "Session",
            infoReport.date_report || "",
            "Pay out",
            sumPayout,
            "Baccarat",
            sumBaccarat,
          ],
          ["", "", "Bonus", sumBonus],
          [], // Row 5 blank spacer
          // Row 6 (Table titles)
          [
            "Match Report",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "Bonus",
            "",
            "",
            "",
            "",
            "Extra",
            "",
            "",
          ],
          // Row 7 (Table headers)
          [
            "#",
            "Customer id",
            "Customer name",
            "Match",
            "Machine",
            "Time",
            "Staff",
            "Checkin by",
            "", // index 8 spacer
            "Staff",
            "Time",
            "Machine",
            "Cash out",
            "", // index 13 spacer
            "Staff",
            "Detail",
            "Extra (USD)",
          ],
        ];

        const listMatch = data.listMatch || [];
        const listBonus = data.listBonus || [];
        const listExtra = data.listExtra || [];

        const matchRowCount = listMatch.length + 1;
        const bonusRowCount = listBonus.length + 1;
        const extraRowCount = listExtra.length + 1;

        const maxRows = Math.max(matchRowCount, bonusRowCount, extraRowCount);

        for (let i = 0; i < maxRows; i++) {
          const row = Array(17).fill("");

          // Match Report column (index 0 to 7)
          if (i < listMatch.length) {
            const m = listMatch[i];
            row[0] = i + 1;
            row[1] = m.customer_id;
            row[2] = m.customer_name;
            row[3] = Number(m.match_amount) || 0;
            row[4] = m.machine_number || "";
            row[5] = m.time_match;
            row[6] = m.staff_name || "";
            row[7] = m.checkin_by || "";
          } else if (i === listMatch.length) {
            row[0] = `Match Total: ${numberFormat(sumMatch)}`;
          }

          // Bonus column (index 9 to 12)
          if (i < listBonus.length) {
            const b = listBonus[i];
            row[9] = b.staff_name || "";
            row[10] = b.time_bonus;
            row[11] = b.machine_number || "";
            row[12] = Number(b.cash_out_amount) || 0;
          } else if (i === listBonus.length) {
            row[9] = `Bonus Total: ${numberFormat(sumBonus)}`;
          }

          // Extra column (index 14 to 16)
          if (i < listExtra.length) {
            const ext = listExtra[i];
            row[14] = ext.staff_name || "";
            row[15] = ext.cost_category || "";
            row[16] = Number(ext.amount) || 0;
          } else if (i === listExtra.length) {
            row[14] = `Extra Total: ${numberFormat(sumExtra)}`;
          }

          sheetData.push(row);
        }

        const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merges configurations
        const merges: any[] = [
          // Table titles
          { s: { r: 6, c: 0 }, e: { r: 6, c: 7 } }, // Match Report
          { s: { r: 6, c: 9 }, e: { r: 6, c: 12 } }, // Bonus
          { s: { r: 6, c: 14 }, e: { r: 6, c: 16 } }, // Extra
        ];

        // Total Row Merges
        const matchTotalRowIdx = 8 + listMatch.length;
        merges.push({
          s: { r: matchTotalRowIdx, c: 0 },
          e: { r: matchTotalRowIdx, c: 7 },
        });

        const bonusTotalRowIdx = 8 + listBonus.length;
        merges.push({
          s: { r: bonusTotalRowIdx, c: 9 },
          e: { r: bonusTotalRowIdx, c: 12 },
        });

        const extraTotalRowIdx = 8 + listExtra.length;
        merges.push({
          s: { r: extraTotalRowIdx, c: 14 },
          e: { r: extraTotalRowIdx, c: 16 },
        });

        worksheet["!merges"] = merges;

        // Columns widths configuration
        const wscols = [
          { wch: 6 }, // # (Col A)
          { wch: 15 }, // Customer id (Col B)
          { wch: 20 }, // Customer name (Col C)
          { wch: 12 }, // Match (Col D)
          { wch: 12 }, // Machine (Col E)
          { wch: 20 }, // Time (Col F)
          { wch: 15 }, // Staff (Col G)
          { wch: 18 }, // Checkin by (Col H)
          { wch: 4 }, // spacer (Col I)
          { wch: 15 }, // Staff (Col J)
          { wch: 20 }, // Time (Col K)
          { wch: 12 }, // Machine (Col L)
          { wch: 12 }, // Cash out (Col M)
          { wch: 4 }, // spacer (Col N)
          { wch: 15 }, // Staff (Col O)
          { wch: 18 }, // Detail (Col P)
          { wch: 15 }, // Extra (USD) (Col Q)
        ];
        worksheet["!cols"] = wscols;

        // Apply formatting & styles to Metadata Block 1 (A1:B4 -> Rows 0-3, Cols 0-1)
        for (let r = 0; r <= 3; r++) {
          for (let c = 0; c <= 1; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 0 ? { bold: true } : undefined,
              alignment: { vertical: "center" },
            };
          }
        }

        // Apply formatting & styles to Metadata Block 2 (C1:D5 -> Rows 0-4, Cols 2-3)
        for (let r = 0; r <= 4; r++) {
          for (let c = 2; c <= 3; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 2 ? { bold: true } : undefined,
              alignment:
                c === 3
                  ? { horizontal: "right", vertical: "center" }
                  : { vertical: "center" },
            };
          }
        }

        // Apply formatting & styles to Metadata Block 3 (E1:F4 -> Rows 0-3, Cols 4-5)
        for (let r = 0; r <= 3; r++) {
          for (let c = 4; c <= 5; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 4 ? { bold: true } : undefined,
              alignment:
                c === 5
                  ? { horizontal: "right", vertical: "center" }
                  : { vertical: "center" },
            };
          }
        }

        // Apply formatting & styles to Metadata Block 4 (H1:I2 -> Rows 0-1, Cols 7-8)
        for (let r = 0; r <= 1; r++) {
          for (let c = 7; c <= 8; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              font: c === 7 ? { bold: true } : undefined,
              alignment:
                c === 8
                  ? { horizontal: "right", vertical: "center" }
                  : { vertical: "center" },
            };
          }
        }

        // Apply styles to Match Report Table
        for (let r = 6; r <= matchTotalRowIdx; r++) {
          for (let c = 0; c <= 7; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === matchTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 3) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        // Apply styles to Bonus Table
        for (let r = 6; r <= bonusTotalRowIdx; r++) {
          for (let c = 9; c <= 12; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === bonusTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 12) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        // Apply styles to Extra Table
        for (let r = 6; r <= extraTotalRowIdx; r++) {
          for (let c = 14; c <= 16; c++) {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            if (!worksheet[cellRef]) {
              worksheet[cellRef] = { t: "s", v: "" };
            }
            const isTitle = r === 6;
            const isHeader = r === 7;
            const isTotal = r === extraTotalRowIdx;
            let cellAlign: any = undefined;
            if (isTitle || isHeader || isTotal) {
              cellAlign = { horizontal: "center", vertical: "center" };
            } else if (c === 16) {
              cellAlign = { horizontal: "right", vertical: "center" };
            }
            worksheet[cellRef].s = {
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
              alignment: cellAlign,
              font: isTitle
                ? { bold: true, sz: 12 }
                : isHeader || isTotal
                  ? { bold: true }
                  : undefined,
            };
          }
        }

        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Manager Detail Report",
        );

        const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "buffer",
        });

        const dataBlob: Blob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(dataBlob);
        const filename = `Manager_Report_${infoReport.staff_name || "Detail"}_${infoReport.date_report || dayjs().format("YYYYMMDD")}.xlsx`;
        link.download = filename;
        link.click();

        openNotification("success", "Export detail report successful!");
      } else {
        openNotification("error", res?.message || "No data returned!");
      }
    } catch (error) {
      console.error("Error exporting Excel:", error);
      openNotification("error", "Oops, something went wrong during export!");
    } finally {
      setExportingId(null);
    }
  };
  const columns: TableColumnsType<DataType> = [
    // {
    //   title: "Bank start",
    //   dataIndex: "start_amount",
    //   align: "right",
    //   render: (text) => <span>{numberFormat(text)}</span>,
    // },
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      render: (text, record) => (
        <Flex align="center" gap={4}>
          <Button
            icon={pencil}
            className="rs-button edit"
            onClick={() => {
              setSelectedItem(record?.report_id);
              setShowEditPopup(true);
            }}
          />
          <Button
            icon={<DocumentDownload />}
            className="rs-button edit"
            loading={exportingId === record.report_id}
            onClick={() => exportDetailReport(record.report_id)}
          />
        </Flex>
      ),
    },
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "Bank",
      dataIndex: "addbank",
      align: "right",
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          // className="text-light"
          onClick={() => {
            SetIsShowBank(true);
            SetDataViewBank(record);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Profit machine",
      dataIndex: "profit",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
    {
      title: "Money of system",
      dataIndex: "money_of_system",
      align: "right",
      render: (text, record, index) => (
        <div className="ctrl-td-final">
          {numberFormat(record.money_of_system)}
          {/* {record.money_of_system !== record.money_proof && (
            <Warning2 size="20" color="#f9d361" variant="Bulk" />
          )} */}
        </div>
      ),
    },
    {
      title: "Cash on hand",
      dataIndex: "money_in_proof",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
    {
      title: "Zelle",
      dataIndex: "zelle",
      align: "right",
      render: (text, record: DataType) => (
        <ZelleCell record={record} onSave={handleSaveZelle} />
      ),
    },
    {
      title: "Baccarat",
      dataIndex: "baccarat",
      align: "right",
      render: (text, record: DataType) => (
        <BaccaratCell record={record} onSave={handleSaveBaccarat} />
      ),
    },
    {
      title: "Loss",
      align: "right",
      // render: (text, record) => <span>{ numberFormat(record.final - record.money_proof) }</span>
      render: (text, record) => (
        <span>
          {numberFormat(
            record.loss +
              Number(record?.zelle) -
              (Number(record?.baccarat) || 0),
          )}
        </span>
      ),
    },
    {
      title: "Final",
      dataIndex: "final",
      align: "right",
      render: (text, record: any, index) => {
        const finalNumber =
          record.money_of_system - record.addbank + (record?.baccarat ?? 0);
        return (
          <span style={{ color: finalNumber < 0 ? "#FD8181" : "#55c790" }}>
            {numberFormat(finalNumber)}
          </span>
        );
      },
    },
    // {
    //   title: 'Final',
    //   dataIndex: 'final',
    //   align: 'right',
    //   render: (text, record, index) => <span>{ numberFormat(text) }</span>,
    // },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Staff Report",
      dataIndex: "staff",
    },
    // {
    //   title: 'Voucher',
    //   dataIndex: 'voucher',
    //   align: 'right',
    //   render: (text) => <span>{ numberFormat(text) }</span>
    // },
    {
      title: "Bonus",
      dataIndex: "bonus_total",
      align: "right",
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          // className="text-light"
          onClick={() => {
            setIsShowBonus(true);
            setDataViewBonus(record);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Labor",
      dataIndex: "labor",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
    {
      title: "Match",
      dataIndex: "match_total",
      align: "right",
      // render: (text) => <span>{numberFormat(text)}</span>,
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          // className="text-light"
          onClick={() => {
            setIsShowMatch(true);
            setDataViewMatch(record?.report_id);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Extra",
      dataIndex: "extra",
      align: "right",
      render: (text, record: any) => (
        <span
          style={{ borderBottom: "1px solid", cursor: "pointer" }}
          // className="text-light"
          onClick={() => {
            SetIsShow(true);
            SetDataView(record);
          }}
        >
          {numberFormat(text)} <EyeOutlined />
        </span>
      ),
    },
    {
      title: "Payout of system",
      dataIndex: "payout_total",
      align: "right",
      render: (text) => <span>{numberFormat(text)}</span>,
    },
  ];

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchStaffName?: string;
    fromDate?: string;
    toDate?: string;
    isSaveTime?: number;
  }>({
    limit: 10,
    page_number: 1,
  });

  const getItems = async () => {
    setTableLoading(true);

    const res = await mixPostV1("/api/webAdmin/greportTotalIncome.php", params);
    setIsSaveTime(false);
    if (res.status === 1) {
      const result: any = [];
      setSumReport(res.sum_report);

      res.data.map((item: any, index: number) =>
        result.push({
          ...item,
          key: `${index}-${item.report_id}`,
          date: item.date_report,
          staff: item.staff_name,
          statusfinal: 0,
          foodsupply: item.food_supply,
          proof: item.money_proof,
          final: item.final,
          profit: item.profit,
          is_edit: item.is_edit,
          zelle: item.zelle,
          baccarat: item.baccarat,
        }),
      );
      setItems({
        ...items,
        list: result,
        total: res.totalRecord,
      });
      getComboTime();
      setTableLoading(false);
    }
  };
  const getComboTime = async () => {
    setTableLoading(true);
    const res = await mixGetV1("/api/webAdmin/gComboTimeRangeReportIncome.php");
    if (res.status === 1) {
      setComboRangeTime(res.data ?? []);
    }
  };

  const lastParamsRef = useRef<string>("");

  useEffect(() => {
    if (Number(can_view_report_income) === 0) {
      navigate("/");
    } else {
      const paramsStr = JSON.stringify(params);
      if (lastParamsRef.current === paramsStr) return;
      lastParamsRef.current = paramsStr;
      getItems();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchStaffName: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };

  // On Date Change
  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[],
  ) => {
    setSelectedId(null);
    setRangeValue(dates as [Dayjs | null, Dayjs | null] | null);
    if (dates) {
      setParams({
        ...params,
        page_number: 1,
        fromDate: dateStrings[0],
        toDate: dateStrings[1],
        isSaveTime: isSaveTime ? 1 : 0,
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        fromDate: "",
        toDate: "",
        isSaveTime: 0,
      });
    }
  };
  //xóa filter
  const handleDelete = (date_id: number) => {
    const newData = comboRangeTime.filter(
      (item: any) => item.date_id !== date_id,
    );
    setComboRangeTime(newData);
    const res = mixPostV1("/api/webAdmin/deleteTimeRangeFilter.php", {
      date_id: date_id,
    });
  };
  const onSeachRange = (start_time: string, end_time: string) => {
    if (start_time !== "" && end_time !== "") {
      setParams({
        ...params,
        page_number: 1,
        fromDate: start_time,
        toDate: end_time,
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        fromDate: "",
        toDate: "",
        isSaveTime: 0,
      });
    }
  };

  // END SEARCH

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/reportTotalIncome.php",
        customParams,
      );

      if (res.status === 0) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Date: item.date_report,
        "Staff Report": item.staff_name,
        Bank: numberFormat(item.addbank),
        Bonus: numberFormat(item.bonus_total),
        Labor: numberFormat(item.labor),
        Match: numberFormat(item.match_total),
        Extra: numberFormat(item.extra),
        "Cash on hand": numberFormat(item.money_in_proof),
        Payout: numberFormat(item.payout_total),
        Final: numberFormat(
          Number(item.money_of_system) -
            Number(item.addbank) +
            (Number(item.baccarat) || 0),
        ),
        Zelle: numberFormat(item.zelle),
        Baccarat: numberFormat(item.baccarat),
        Loss: numberFormat(
          Number(item.loss) + Number(item.zelle) - (Number(item.baccarat) || 0),
        ),
        "Profit machine": numberFormat(item.profit),
        "Money of system": numberFormat(item.money_of_system),
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Total Income Report"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="report-total-income-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Report" },
            { title: "Total Income" },
          ]}
          title="Total Income"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by name"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input t-input-ctrl table-filter-block__search"
            allowClear
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
            // style={{ maxWidth: 250 }}
          />

          <RangePicker
            allowClear
            value={rangeValue}
            className="rs-range-picker ranger-filter"
            suffixIcon={<Calendar2 size={20} />}
            separator={<LineOutlined />}
            placeholder={["From date", "To date"]}
            // disabledDate={disabledDate}
            onChange={onRangeChange}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            renderExtraFooter={() => (
              <Checkbox
                checked={isSaveTime}
                onChange={(e) => setIsSaveTime(e.target.checked)}
              >
                Remember this time range
              </Checkbox>
            )}
          />
          <Select
            ref={selectRef}
            placeholder="Select saved time range"
            style={{ width: 290 }}
            value={selectedId ?? undefined}
            onChange={(value) => {
              setSelectedId(value);
              if (value !== null) {
                setParams({
                  ...params,
                  page_number: 1,
                  fromDate: "",
                  toDate: "",
                  isSaveTime: 0,
                });
              }
            }}
            className="rs-select w-186 grid-area-level custom-white-select small-select"
            allowClear={selectedId !== null}
            dropdownRender={(menu) => (
              <div>
                {comboRangeTime.length > 0 ? (
                  comboRangeTime.map((item) => (
                    <div
                      key={item.date_id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "4px 12px",
                        cursor: "pointer",
                        backgroundColor:
                          selectedId === item.date_id ? "#e6f7ff" : "",
                      }}
                      onClick={() => {
                        setSelectedId(item.date_id);
                        setRangeValue(null);
                        onSeachRange(item.from_date, item.to_date);
                        // 👉 Thủ công tắt dropdown
                        setTimeout(() => {
                          selectRef.current?.blur(); // hoặc open: false nếu dùng state
                        }, 100);
                      }}
                    >
                      <span>{item.label}</span>
                      <Button
                        type="text"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={(e) => {
                          e.stopPropagation(); // ❗ tránh trigger onClick chọn
                          handleDelete(item.date_id);
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <div
                    style={{ padding: 8, textAlign: "center", color: "#999" }}
                  >
                    No saved ranges
                  </div>
                )}
              </div>
            )}
            optionLabelProp="label"
          >
            {comboRangeTime.map((item) => (
              <Select.Option
                key={item.date_id}
                value={item.date_id}
                label={item.label} // label hiển thị
              >
                {item.label}
              </Select.Option>
            ))}
          </Select>
          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto t-h40"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <div className="t-table-block">
          <Table
            columns={columns}
            dataSource={items.list}
            className="rs-table table-text-nowrap match-height"
            showSorterTooltip={false}
            loading={tableLoading}
            scroll={{ x: true }}
            pagination={{
              current: params.page_number,
              pageSize: params.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange(e),
            }}
            onChange={onTableChange}
            rowClassName={(record) => (record.is_edit === 1 ? "row-edit" : "")}
            summary={() => {
              return (
                items.list.length > 0 && (
                  <Table.Summary.Row className="custom-bg-table">
                    <Table.Summary.Cell index={0} colSpan={2}>
                      Total
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1}>
                      {numberFormat(sumReport.total_addbank)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}>
                      {numberFormat(sumReport.total_profit)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}>
                      {numberFormat(sumReport.total_money_system)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={4}>
                      {numberFormat(sumReport.total_money_proof)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5}>
                      <span style={{ color: "#f9d361", fontWeight: "bold" }}>
                        {numberFormat(sumReport.total_zelle)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={6}>
                      <span style={{ color: "#ffffff", fontWeight: "bold" }}>
                        {numberFormat(sumReport.total_baccarat)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={7}>
                      <span
                        style={{
                          color:
                            sumReport.total_loss < 0 ? "#FD8181" : "#55c790",
                          fontWeight: "bold",
                        }}
                      >
                        {numberFormat(sumReport.total_loss)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={8}>
                      <span
                        style={{
                          color:
                            sumReport.total_final < 0 ? "#FD8181" : "#55c790",
                          fontWeight: "bold",
                        }}
                      >
                        {numberFormat(sumReport.total_final)}
                      </span>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={9} align="center">
                      -
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={10} align="left">
                      -
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={11}>
                      {numberFormat(sumReport.total_bonus)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={12}>
                      {numberFormat(sumReport.total_labor)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={13}>
                      {numberFormat(sumReport.total_match)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={14}>
                      {numberFormat(sumReport.total_extra)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={15}>
                      {numberFormat(sumReport.total_payout)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                )
              );
            }}
          />
        </div>
      </Layout>

      {isShow && dataView && (
        <ExtraView
          isShow={isShow}
          dataView={dataView}
          onPopupClose={() => {
            SetIsShow(false);
            SetDataView(false);
          }}
        />
      )}
      {isShowBank && dataViewBank && (
        <BankView
          isShow={isShowBank}
          dataView={dataViewBank}
          onPopupClose={() => {
            SetIsShowBank(false);
            SetDataViewBank(false);
          }}
        />
      )}
      {isShowBonus && dataViewBonus && (
        <BonusDetailView
          isShow={isShowBonus}
          dataView={dataViewBonus}
          onPopupClose={() => {
            setIsShowBonus(false);
            setDataViewBonus(null);
          }}
        />
      )}
      {isShowMatch && dataViewMatch && (
        <MatchDetailView
          isShow={isShowMatch}
          dataView={dataViewMatch}
          onPopupClose={() => {
            setIsShowMatch(false);
            setDataViewMatch(undefined);
          }}
        />
      )}
      {showEditPopup && (
        <EditReportIncomePoup
          isShow={showEditPopup}
          item={selectedItem}
          onPopupClose={() => setShowEditPopup(false)}
          onSuccess={getItems}
        />
      )}
    </>
  );
};

export default ReportTotalIncome;
